import { ReactComponent as plusIcon } from '@epam/assets/icons/common/action-add-12.svg';
import { Button } from '@epam/promo';
import { useNavigate } from 'react-router-dom';

import botImage from 'assets/icons/bot-pic.svg';
import { taskRoutes } from 'router/taskRoutes';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { resetDraft as resetDraftTask } from 'store/task';
import { resetDraft as resetDraftBroadcast } from 'store/broadcast';
import { useGetHomeData } from './useGetHomeData';
import { HomeSection } from './HomeSection';
import css from './HomePage.module.scss';

export const HomePage = () => {
  const navigate = useNavigate();
  const { data, isPending } = useGetHomeData();

  return (
    <div className={css.container}>
      <img alt="Bot" className={css.bot__image} src={botImage} />
      <div className={css.grid}>
        {data.map((item, i) => (
          <HomeSection
            {...item}
            key={`${item?.title}_${i}`}
            isLoading={isPending}
          />
        ))}

        <Button
          caption="Add a new task"
          color="blue"
          icon={plusIcon}
          rawProps={{ 'data-testid': 'add-task-btn' }}
          onClick={() => {
            resetDraftTask();
            navigate(taskRoutes.create);
          }}
        />
        <Button
          caption="Add a new broadcast"
          color="blue"
          icon={plusIcon}
          rawProps={{ 'data-testid': 'add-broadcast-btn' }}
          onClick={() => {
            resetDraftBroadcast();
            navigate(broadcastRoutes.create);
          }}
        />
      </div>
    </div>
  );
};
